import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { Container } from './styles';

export default class Notificacao extends Component {
    componentDidMount() {
        // toast.info(this.props.msg);
        toast.info(() => (<div dangerouslySetInnerHTML={{ __html: this.props.msg }}></div>));

    }

    render() {
        return (<>
            {
                this.props.msg && this.props.msg.trim() != "" ? (
                    <div className="row" >
                        <div className={"col-sm-12 alert " + this.props.nameclass}>
                            <div dangerouslySetInnerHTML={{ __html: this.props.msg }}></div>
                            
                            <ToastContainer
                                position="top-right"
                                autoClose={5000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnVisibilityChange
                                draggable
                                pauseOnHover />
                        </div>
                    </div>
                ) : null
            }
        </>);
    }
}
